import React, { ReactNode } from 'react';
import useCountryFeatureFlags, { CrmisCountryFlags } from '../../hooks/useCrmisCountryFlags';

export interface FeatureFlagStore {
  featureFlags?: CrmisCountryFlags;
  loading: boolean;
  error: boolean;
}

export const CrmisFeatureFlagsContext = React.createContext<FeatureFlagStore>({
  featureFlags: undefined,
  loading: false,
  error: false
});

export interface FeatureFlagProviderProps {
  children: ReactNode;
  countryCode: string;
}

export const CrmisFeatureFlagsProvider = ({ children, countryCode }: FeatureFlagProviderProps): JSX.Element => {
  const { countryFlags, loading, error } = useCountryFeatureFlags(countryCode);

  return (
    <CrmisFeatureFlagsContext.Provider value={{ featureFlags: countryFlags, loading, error }}>
      {children}
    </CrmisFeatureFlagsContext.Provider>
  )
}
